'use client'

import React from 'react'
import { Container } from 'react-bootstrap'

import Banner from './component/Banner'
import AttributesDetails from './component/AttributesDetails'

const ProductDetails = ({ response }) => {
	return (
		<Container fluid='lg'>
			<Banner categoryData={response} />
			<AttributesDetails categoryData={response} />
		</Container>
	)
}

export default ProductDetails
